import createLucideIcon from '../createLucideIcon';
import { IconNode } from '../types';

export const __iconNode: IconNode = [
  ['path', { d: 'M16 5H3', key: 'm91uny' }],
  ['path', { d: 'M16 12H3', key: '1a2rj7' }],
  ['path', { d: 'M9 19H3', key: 's61nz1' }],
  ['path', { d: 'm16 16-3 3 3 3', key: '117b85' }],
  ['path', { d: 'M21 5v12a2 2 0 0 1-2 2h-6', key: 'hey24a' }],
];

/**
 * @component @name ListEnd
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTYgNUgzIiAvPgogIDxwYXRoIGQ9Ik0xNiAxMkgzIiAvPgogIDxwYXRoIGQ9Ik05IDE5SDMiIC8+CiAgPHBhdGggZD0ibTE2IDE2LTMgMyAzIDMiIC8+CiAgPHBhdGggZD0iTTIxIDV2MTJhMiAyIDAgMCAxLTIgMmgtNiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/list-end
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const ListEnd = createLucideIcon('list-end', __iconNode);

export default ListEnd;
